import sortBy from "lodash/sortBy";

import i18n from "./i18n";

function workExperienceSorting(experience) {
  if (experience.to) {
    return "a" + experience.from;
  } else {
    return "b" + experience.from;
  }
}

export function sortWorkExperiences(experiences) {
  return sortBy(experiences, workExperienceSorting).reverse();
}

export function getPositionFromUser(user) {
  let position = user.position;
  if (user.workExperiences && user.workExperiences.length > 0) {
    const exp = sortWorkExperiences(user.workExperiences)[0];
    if (exp.role && exp.company) {
      position = i18n.t("component.talent_short_view.role_at_company", exp);
    } else if (exp.role) {
      position = exp.role;
    }
  }
  return position;
}
